<template>
  <app-accordion-item
    variant="outline-light"
    size="lg"
    block
    :state="computedState"
    :disabled="isValid"
    :visible="expanded"
    :title="$trans('onboard.requirements.section.personal_data.title')"
  >
    <b-form @submit.prevent="onSubmit">
      <app-form-input
        v-if="!hasPhoneNumber"
        v-model="form.phoneNumber"
        :placeholder="$trans('ui.phone_number')"
        variant="white"
        type="tel"
        :error="errorMessages.phoneNumber"
      />
      <app-form-birthday
        v-if="!hasBirthday"
        v-model="form.birthday"
        variant="white"
        :error="errorMessages.birthday"
      />
      <app-form-gender
        v-if="!hasGender"
        v-model="form.gender"
        variant="white"
        block
        :error="errorMessages.gender"
      />
      <app-button
        :disabled="submitted"
        :loading="submitted"
        type="submit"
        variant="light"
        block
        class="mt-4"
        >{{ "ui.save" | trans }}</app-button
      >
    </b-form>
  </app-accordion-item>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AppAccordionItem from "@/components/ui/Accordion/AccordionItem";
import AppFormInput from "@/components/form/FormInput";
import AppButton from "@/components/ui/Button";
import { createValidationError } from "@/utils/validation";
import AppFormGender from "@/components/form/FormGender";
import AppFormBirthday from "@/components/form/FormBirthday";

export default {
  name: "AppPersonalData",
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false,
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    AppFormBirthday,
    AppFormGender,
    AppButton,
    AppFormInput,
    AppAccordionItem,
  },
  computed: {
    ...mapGetters("customers", ["customer"]),
    computedState() {
      return this.isValid ? "valid" : "invalid";
    },
    formData() {
      return {
        phoneNumber: this.form.phoneNumber || null,
        birthday: this.form.birthday || null,
        gender: this.form.gender || null,
      };
    },
    hasPhoneNumber() {
      return !!this.customer.phoneNumber;
    },
    hasBirthday() {
      return !!this.customer.birthday;
    },
    hasGender() {
      return !!this.customer.gender && this.customer.gender !== "u";
    },
    isValid() {
      return this.hasPhoneNumber && this.hasBirthday && this.hasGender;
    },
  },
  methods: {
    ...mapActions("customers", ["updateCustomer"]),
    async onSubmit() {
      try {
        this.resetErrorMessages();
        this.submitted = true;
        await this.updateCustomer(this.formData);
      } catch (e) {
        const ve = createValidationError(e);
        this.errorMessages.phoneNumber = ve.errors.phoneNumber || null;
        this.errorMessages.birthday = ve.errors.birthday || null;
        this.errorMessages.gender = ve.errors.gender || null;
      } finally {
        this.submitted = false;
      }
    },
    resetErrorMessages() {
      Object.keys(this.errorMessages).forEach(
        key => (this.errorMessages[key] = null)
      );
    },
  },
  watch: {
    customer: {
      handler(value) {
        this.form.phoneNumber = value.phoneNumber;
        this.form.birthday = value.birthday;
        this.form.gender = value.gender !== "u" ? value.gender : null;
        this.errorMessages.phoneNumber =
          !this.hasPhoneNumber || this.errorMessages.phoneNumber;
        this.errorMessages.birthday =
          !this.hasBirthday || this.errorMessages.birthday;
        this.errorMessages.gender =
          !this.hasGender || this.errorMessages.gender;
      },
      immediate: true,
    },
    isValid: {
      handler(value) {
        this.$emit("input", value);
      },
      immediate: true,
    },
  },
  data() {
    return {
      submitted: false,
      errorMessages: {
        phoneNumber: null,
        birthday: null,
        gender: null,
      },
      form: {
        phoneNumber: null,
        birthday: null,
        gender: null,
      },
    };
  },
};
</script>

<style scoped></style>
